import { useTranslation } from 'react-i18next';
import { Flex, Typography } from 'antd';
import { FileOutlined } from '@ant-design/icons';
import { useGetClientInsuranceLink } from 'api/clients/use-get-client-insurance-link';
import { useDownloadFile } from 'shared/hooks/use-download-file';
import { ClientInsurancePreview } from 'components/clients/client-insurance/components/client-insurance-preview';
import styles from './client-insurance-file-control.module.scss';
import type { IClientInsuranceFileControlProps } from './types';
import { getInsuranceFileTypeLabel } from './utils';

export const ClientInsuranceFileControl = (props: IClientInsuranceFileControlProps) => {
  const { clientId, fileName, insuranceId, mimeType } = props;
  const { t } = useTranslation('client');

  const downloadFile = useDownloadFile();
  const { mutateAsync: getInsuranceLink } = useGetClientInsuranceLink();

  const handleDownload = async () => {
    const result = await getInsuranceLink({ clientId, insuranceId });
    downloadFile(result.url);
  };

  return (
    <Flex className={styles.file} align='center' gap={10}>
      <Flex className={styles.icon} align='center' justify='center'>
        <FileOutlined />
      </Flex>
      <Flex className={styles.details} vertical>
        <Typography.Link className={styles.fileName} ellipsis onClick={handleDownload}>
          {fileName}
        </Typography.Link>
        <Typography.Text className={styles.description}>
          {getInsuranceFileTypeLabel(fileName)} · {t('insurance_file_unchanged')}
        </Typography.Text>
      </Flex>
      <ClientInsurancePreview clientId={clientId} insuranceId={insuranceId} fileName={fileName} mimeType={mimeType} />
    </Flex>
  );
};
